const getActions = (productAdvantages = []) =>
  productAdvantages.reduce(
    (res, cur) => {
      if (cur?.isAction) {
        res.actions.push(cur);
      } else {
        res.advantages.push(cur);
      }

      return res;
    },
    {
      advantages: [],
      actions: [],
    }
  );

export const normalizeProduct = ({ data }) => {
  const {
    id,
    slug,
    productId,
    vendorId,
    productName,
    productSlug,
    loanRateYearRange,
    standardUird,
    baseCalculatedRate,
    calculatedRateLimit,
    periodicalRateCollection,
    loanRateYearComment,
    loanSecurityComment,
    effectiveInterestRateComment,
    downPaymentComment,
    oneTimeCommission,
    oneTimeCommissionAmount,
    oneTimeCommissionComment,
    monthlyCommission,
    monthlyCommissionAmount,
    monthlyCommissionComment,
    effectiveInterestRate,
    decisionActiveTerm,
    paymentChannel,
    loanLimitMaxFirst,
    requiredDocument,
    loanLimitNumber,
    productEssentialCharacteristicsUrl,
    productUserWarningUrl,
    advantages: benefits,
    bankProductUrl,
    termMonths,
    currency,
    loanLimitNumberComment,
    loanPurpose,
    provisionForm,
    repayment,
    interestRate,
    isPrepayment,
    prepaymentDescription,
    commission,
    commissionPercent,
    commissionDescription,
    isDownPayment,
    downPayment,
    reviewDays,
    isOnlineAvailable,
    supportPrograms,
    supportProgramsDescription,
    loanRecipient,
    ownershipForm,
    businessSize,
    minimalBusinessRegistrationPeriod,
    minimalBusinessRegistrationPeriodComment,
    revenue,
    activityScope,
    isLoanSecurity,
    loanSecurity,
    isLoanSurety,
    loanSuretyAmount,
    requestConsiderationTermDays,
    onlineSubmission,
    onlineCabinet,
    personalAssistance,
    supportProgram,
    aboutSupportProgram,
    additionalRequirements,
    trackingUrl,
    keitaroMinfinUrl,
    monthlyCommissionPercent,
    oneTimeCommissionPercent,
    other,
  } = data;

  const { advantages, actions } = getActions(data?.productAdvantages || []);

  return {
    id,
    slug,
    productId,
    vendorId,
    productName,
    productSlug,
    loanRateYear: loanRateYearRange,
    standardUird,
    baseCalculatedRate,
    calculatedRateLimit,
    periodicalRateCollection: Object.values(periodicalRateCollection || {}).map(
      (item) => item
    ),
    loanRateYearComment,
    loanSecurityComment,
    effectiveInterestRateComment,
    downPaymentComment,
    oneTimeCommission,
    oneTimeCommissionAmount,
    oneTimeCommissionComment,
    monthlyCommission,
    monthlyCommissionAmount,
    monthlyCommissionComment,
    effectiveInterestRate,
    loanLimitNumber,
    loanLimitNumberMax: loanLimitNumber?.max || 0,
    loanLimitNumberMin: loanLimitNumber?.min || 0,
    currency: currency?.toLowerCase(),
    productEssentialCharacteristicsUrl,
    productUserWarningUrl,
    benefits,
    advantages,
    actions,
    bankProductUrl,
    termMonths,
    loanLimitNumberComment,
    loanPurpose,
    provisionForm,
    repayment,
    interestRate,
    isPrepayment,
    prepaymentDescription,
    commission,
    commissionPercent,
    commissionDescription,
    isDownPayment,
    downPayment,
    reviewDays,
    isOnlineAvailable,
    supportPrograms,
    supportProgramsDescription,
    loanRecipient,
    ownershipForm,
    decisionActiveTerm,
    paymentChannel,
    loanLimitMaxFirst,
    requiredDocument,
    businessSize,
    minimalBusinessRegistrationPeriod,
    minimalBusinessRegistrationPeriodComment,
    revenue,
    activityScope,
    isLoanSecurity,
    loanSecurity,
    isLoanSurety,
    loanSuretyAmount,
    requestConsiderationTermDays,
    onlineSubmission,
    onlineCabinet,
    personalAssistance,
    supportProgram,
    aboutSupportProgram,
    additionalRequirements,
    trackingUrl: trackingUrl || keitaroMinfinUrl || '',
    monthlyCommissionPercent,
    oneTimeCommissionPercent,
    other,
  };
};

export const normalizeProductsList = ({ data }) =>
  data.reduce((res, cur) => {
    const {
      id,
      slug,
      productId,
      vendorId,
      productName,
      productSlug,
      loanRateYearRange,
      standardUird,
      baseCalculatedRate,
      calculatedRateLimit,
      periodicalRateCollection,
      effectiveInterestRate,
      loanLimitMaxFirst,
      loanLimitNumber,
      loanLimitNumberComment,
      productEssentialCharacteristicsUrl,
      productUserWarningUrl,
      advantages: benefits,
      bankProductUrl,
      termMonths,
      loanPurpose,
      provisionForm,
      repayment,
      isLoanSecurity,
      loanSecurity,
      trackingUrl,
      keitaroMinfinUrl,
      isPriorityMinfin,
      currency,
      loanRateYearComment,
      monthlyCommissionPercent,
    } = cur;

    const { advantages, actions } = getActions(cur?.productAdvantages || []);

    return [
      ...res,
      {
        id,
        slug,
        productId,
        vendorId,
        productName,
        productSlug,
        loanRateYear: loanRateYearRange,
        standardUird,
        baseCalculatedRate,
        calculatedRateLimit,
        periodicalRateCollection: Object.values(
          periodicalRateCollection || {}
        ).map((item) => item),
        loanRateYearComment,
        effectiveInterestRate,
        loanLimitMaxFirst,
        loanLimitNumber,
        loanLimitNumberComment,
        loanLimitNumberMax: loanLimitNumber?.max || 0,
        loanLimitNumberMin: loanLimitNumber?.min || 0,
        currency: currency?.toLowerCase(),
        productEssentialCharacteristicsUrl,
        productUserWarningUrl,
        benefits,
        advantages,
        actions,
        bankProductUrl,
        isPriorityMinfin,
        termMonths,
        termMonthsMax: termMonths?.max || 0,
        loanPurpose,
        provisionForm,
        repayment,
        isLoanSecurity,
        loanSecurity,
        trackingUrl: trackingUrl || keitaroMinfinUrl || '',
        monthlyCommissionPercent,
      },
    ];
  }, []);
